import { useCallback } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { CrossIcon } from 'public/icons';

import Button from 'UI/Button';
import IconButton from 'UI/IconButton';

import LogoWithTitle from './logo_with_title.svg';

import styles from './styles.module.scss';

const LearnMoreWidget = ({
  isOpen,
  onClose,
  className,
}) => {
  const handleLearnMoreClick = useCallback(() => {
    window.open('https://www.listedkit.com', '_blank');
  }, []);

  if (!isOpen) {
    return null;
  }

  return (
    <div className={cn({
      [styles.widget]: true,
    }, className)}
    >
      <IconButton
        Icon={CrossIcon}
        onClick={onClose}
        className={styles.crossButton}
      />

      <LogoWithTitle />

      <ul className={styles.list}>
        <li>Save Time on Transaction Management</li>
        <li>Streamline Processes</li>
        <li> Improve Team Collaboration</li>
        <li>Increase Referrals</li>
      </ul>

      <div className={styles.action}>
        <Button onClick={handleLearnMoreClick}>
          Learn more
        </Button>
      </div>
    </div>
  );
};

LearnMoreWidget.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
};

LearnMoreWidget.defaultProps = {
  className: null,
};

export default LearnMoreWidget;
